import { FETCH_BANKS_SUCCESS_ACTION,
         FETCH_BANK_SEARCH_SUCCESS_ACTION
       } from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_BANKS_SUCCESS_ACTION:
      return {
        ...state,
        BankList: action.payload.rows,
        BankCount: action.payload.count
      };

    case FETCH_BANK_SEARCH_SUCCESS_ACTION:
      return {
        ...state,
        bankSearchList: action.payload.rows,
        bankSearchCount:action.payload.count
      };

    default:
      return {
        ...state
      };
  }
}
